const SCROLL_TO_CARD_BUFFER = 50

export function storeScrollPositionInHistoryState(currentViewportDimensions) {
  const anchorElement = document.activeElement?.closest('a')
  let cardLinkClicked
  if (anchorElement) {
    const productParent = anchorElement.closest('.card, .quick-view')
    cardLinkClicked = productParent ? anchorElement.href : undefined
  }
  const scrollRestoration = {
    scrollPosition: scrollY,
    viewportDimensions: currentViewportDimensions,
    cardLinkClicked,
  }
  history.replaceState({ ...history.state, scrollRestoration }, '', location.href)
}

export function restoreLastScrollPositionIfAny(cardsComponent, currentViewportDimensions) {
  if (!history.state.scrollRestoration) return
  const { scrollPosition, cardLinkClicked } = history.state.scrollRestoration

  if (isRestoringExactScrollPosition(currentViewportDimensions)) {
    window.scrollTo(scrollX, scrollPosition)
  } else if (isRestoringScrollPositionOfCardClicked(currentViewportDimensions)) {
    scrollToCardByProductUrl(cardsComponent, cardLinkClicked)
  }
  const cleanState = { ...history.state }
  delete cleanState.scrollRestoration
  history.replaceState(cleanState, '', location.href)
}

export function scrollToCardByProductUrl(cardsComponent, productUrl) {
  const cardElement = cardsComponent?.getCardElementByProductUrl(productUrl)
  if (!cardElement) return
  const headerHeight = document.querySelector('header')?.offsetHeight || 0
  window.scrollBy(
    scrollX,
    cardElement.getBoundingClientRect().top - headerHeight - SCROLL_TO_CARD_BUFFER
  )
}

export function isRestoringScroll(currentViewportDimensions) {
  return (
    isRestoringExactScrollPosition(currentViewportDimensions) ||
    isRestoringScrollPositionOfCardClicked(currentViewportDimensions)
  )
}

export function isRestoringExactScrollPosition(currentViewportDimensions) {
  const { scrollPosition, viewportDimensions } = history.state.scrollRestoration || {}
  return typeof scrollPosition === 'number' && viewportDimensions === currentViewportDimensions
}

export function isRestoringScrollPositionOfCardClicked(currentViewportDimensions) {
  const { cardLinkClicked } = history.state.scrollRestoration || {}
  return !isRestoringExactScrollPosition(currentViewportDimensions) && !!cardLinkClicked
}
